// extracted by mini-css-extract-plugin
export default {"DownloadSection":"DownloadPDF_DownloadSection__wYxGe","DownloadLink":"DownloadPDF_DownloadLink__VTGJf"};